import { mixpanel } from '@fiverr-private/obs';
import { getDataFromStores } from '../../../utils';
import { MIXPANEL_EVENT_PROPERTIES, ACTION_NAMES, MIXPANEL_GENERIC_EVENTS } from '../../constants';
import { Enrichment } from '../types';
import type { GetStartedSubmittedInput, GetStartedSubmittedStore } from './types';
/**
 * The user submitted brand name from the hero section.
 */
export const createReportGetStartedSubmitted =
    (store: GetStartedSubmittedStore, enrichment?: Enrichment) =>
    ({ elementPosition, brandName }: GetStartedSubmittedInput): void => {
        const { BRAND_NAME, CTA_POSITION, BRAND_NAME_FILLED, ACTION } = MIXPANEL_EVENT_PROPERTIES;

        const customPayload = {
            [CTA_POSITION]: elementPosition,
            [BRAND_NAME_FILLED]: !!brandName,
            [BRAND_NAME]: brandName,
            [ACTION]: ACTION_NAMES.START_BRIEF,
            ...enrichment,
        };

        const payload = {
            ...getDataFromStores(store.user, store.referrer, store.fromBoost, store.pageType, store.pagePath),
            ...customPayload,
        };

        mixpanel.track(MIXPANEL_GENERIC_EVENTS.PAGE_ACTION, payload);
    };
